import { useCallback } from 'react';
import { usePostApiV1UserUseridDefaultPassword } from '@/shared/api/generated';

/**
 * Hook para resetar a senha de um usuário para a senha padrão da empresa.
 * Chama POST /api/v1/user/:userId/default-password sem corpo (usa padrão da empresa).
 *
 * @param onSuccess - Callback chamado após reset bem-sucedido
 */
export function useResetPassword(onSuccess: () => void) {
  const { mutate, isPending: isResetting } = usePostApiV1UserUseridDefaultPassword({
    mutation: { onSuccess },
  });

  const resetPassword = useCallback(
    (userId: number) => {
      mutate({ userId });
    },
    [mutate],
  );

  return { resetPassword, isResetting } as const;
}
